export default __webpack_public_path__ + "static/media/IoT.af23e5b3.png";